import { render, staticRenderFns } from "./RepoTree.vue?vue&type=template&id=6a5c6108&scoped=true"
import script from "./RepoTree.vue?vue&type=script&lang=js"
export * from "./RepoTree.vue?vue&type=script&lang=js"
import style0 from "./RepoTree.vue?vue&type=style&index=0&id=6a5c6108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c6108",
  null
  
)

export default component.exports